import React, { useContext, useEffect, useState } from 'react'
import rightNavStyles from './components/RightNav/styles.module.css'
import { appConstants } from './constants'
import { AppContext } from './AppContext'

export function isScrolledIntoView(id) {
  const el = document.getElementById(id)
  if (!el) return false
  var rect = el.getBoundingClientRect()
  var elemTop = rect.top
  var elemBottom = rect.bottom

  // Only completely visible elements return true:
  var isVisible = elemTop >= 0 && elemBottom <= window.innerHeight
  // Partially visible elements return true:
  //isVisible = elemTop < window.innerHeight && elemBottom >= 0;
  return isVisible
}

export const useRightNav = (isMobile, headers) => {
  const { rightNavWidth } = appConstants
  const [selectedHeader, setSelectedHeader] = useState(null)
  const appContext = useContext(AppContext)
  const { height, hideRightNav } = appContext

  function isScrolledIntoView(id) {
    const el = document.getElementById(id)
    if (!el) return false
    const rect = el.getBoundingClientRect()
    const elemTop = rect.top

    // Only completely visible elements return true:
    const isVisible = elemTop >= 0 && elemTop <= 280
    // Partially visible elements return true:
    //isVisible = elemTop < window.innerHeight && elemBottom >= 0;
    return isVisible
  }

  const updateUrlContent = () => {
    let url = window.location.href
    const index = url.indexOf('#')
    if (index !== -1) {
      url = url.substring(0, index - 1)
    }
    url += '/#' + selectedHeader
    window.history.pushState({}, null, url)
  }

  useEffect(() => {
    if (!isMobile) {
      Object.keys(headers).forEach((key, index) => {
        const id = headers[key].id
        const isInView = isScrolledIntoView(id)
        if (isInView) {
          setSelectedHeader(id)
        }
      })
    }
  }, [])

  useEffect(() => {
    const navItem = document.getElementById(`rni${selectedHeader}`)
    const bounds = navItem?.getBoundingClientRect()
    if (bounds) {
      const { y } = bounds
      if (y > height - 60) {
        const navContainer = document.getElementById('rightNav')
        navContainer.scrollTo(0, y - 280)
      }
    }
    if (selectedHeader) {
      setTimeout(() => updateUrlContent())
    }
  }, [selectedHeader])

  const onClickHeader = (id, index) => {
    setSelectedHeader(id)
    document.getElementById(id).scrollIntoView()
  }

  const onBodyScroll = (e) => {
    if (isMobile) return
    Object.keys(headers).forEach((key, index) => {
      const id = headers[key].id
      const isInView = isScrolledIntoView(id)
      if (isInView) {
        setSelectedHeader(id)
      }
    })
  }

  const RightNav = () => {
    return (
      <div
        id='rightNav'
        className={rightNavStyles.rightNav}
        style={{
          height: height - 70,
          width: hideRightNav ? 20 : rightNavWidth
        }}
      >
        {Object.keys(headers).map((key, index) => {
          const { id, label } = headers[key]
          return (
            <div
              key={id}
              id={`rni${id}`}
              className={
                selectedHeader === id
                  ? rightNavStyles.rightNavItemSelected
                  : rightNavStyles.rightNavItem
              }
              onClick={() => onClickHeader(id, index)}
            >
              {label}
            </div>
          )
        })}
        <div style={{ height: 60 }} />
      </div>
    )
  }

  return {
    onBodyScroll,
    RightNav
  }
}
